<template>
<div ref="content" @scroll="handleScroll()">
  <div class="banner" :style="bannerStyle" >
    <div class="banner-head" >{{banner.head}}</div>
    <div class="banner-box" >
      <div class="banner-wrapper">
        <hr class="banner-line">
        <div class="banner-en" >{{banner.headEn}}</div>
        <hr class="banner-line">
      </div>
    </div>
    <div class="banner-subhead">{{banner.subhead}}</div>
  </div>
  <div class="newsTab" >
    <div class="wal">
      <ul class="tab">
        <li class="oh" v-for="(item,index ) in dataList">
          <div class="left">
            <div class="tittle">
              <div style="cursor:pointer" @click="getArticleUrl(item)">{{item.title}}</div>
              <div class="date" >{{item.createtime}}</div>
            </div>
            <div class="msg" v-html="getContent(item)">
            </div>

          </div>
          <div class="right"><img :src="common.getPictureUrl(item)" alt=""></div>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
  export default {
    name: "NewsList",
    methods: {
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.loadData('?current='+this.currentPage+'&size='+this.pageSize);
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;
        this.loadData('?current='+this.currentPage+'&size='+this.pageSize);
      },
      flushPage(){
        this.loadData('?current='+this.currentPage+'&size='+this.pageSize);
      },
      loadData(params) {
        // 下拉的时候可能会多次触发
        if(!this.loading){
          this.loading = true;
        }
        this.common.post('article/page'+params,
          {},(response)=>{
            this.dataList = this.dataList.concat(response.data.content.records);
            this.pageSize = response.data.content.size;
            this.total = response.data.content.total;
            this.currentPage = response.data.content.current;
            this.loading = false;
          }
        )
        this.common.post('content/recentOne', {
            'type':'banner',
            'description':'news',
          },(response)=>{
            this.banner = response.data.content;
            this.bannerStyle = {
              'background-image': 'url('+this.$host+this.banner.image+')'
            };
          }
        )
      },
      getArticleUrl(row){
        this.$router.push('Article/'+row.id)
      },
      getContent(row){
        let content = row.content.replace(/(\n)/g, "");
        content = content.replace(/(\t)/g, "");
        content = content.replace(/(\r)/g, "");
        content = content.replace(/<\/?[^>]*>/g, "");
        content = content.replace(/\s*/g, "");
        if(content){
          // console.log("content: "+content)
          return content.substr(0,300)+
            '...';
        }
      },
      handleScroll() {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        //变量windowHeight是可视区的高度
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

        // if(this.total<=(this.currentPage*this.pageSize)){
        //   console.log("no more data !!")
        // }
        //滚动条到底部 并且有数据
        if (scrollTop + windowHeight === scrollHeight && this.total>(this.currentPage*this.pageSize)) {
          //写后台加载数据的函数
          // console.log("距顶部" + scrollTop + "可视区高度" + windowHeight + "滚动条总高度" + scrollHeight);
          this.loadData('?current=' + (this.currentPage + 1) + '&size=' + this.pageSize);
          this.scroll = true;
          this.list += 1;
        } else {
          this.scroll = false;
        }
      },
    },
    mounted() {
      window.addEventListener('scroll',this.handleScroll);
      this.$nextTick(() => {
        this.loadData('?current='+this.currentPage+'&size='+this.pageSize);
      })
    },
    data() {
      return {
        dataList:[],
        scroll:true,
        currentPage: 1,
        pageSize:10,
        total:1,
        loading:false,
        common:this.$common,
        bannerStyle:{},
        banner:{},
      }
    }
  }
</script>

<style scoped>
  .newsTab {
    padding-top: 70px;
    border-top: 1px solid #f0f0f0
  }

  .newsTab .tab li {
    border: 1px solid #c6c6c6;
    padding: 8.5px;
    padding-left: 40px;
    margin-bottom: 10px
  }

  .newsTab .tab li .right {
    width: 304px;
    height: 226px;
    float: right
  }

  .newsTab .tab li .right img {
    width: 100%
  }
  .wal {
    width: 1200px;
    margin: 0 auto
  }
  .newsTab .tab li .left {
    float: left;
    width: 750px
  }

  .newsTab .tab li .left .msg {
    color: #666666;
    font-size: 14px;
    line-height: 27px;
    white-space: normal
  }

  .newsTab .tab li .left .tittle {
    font-size: 18px;
    color: #333;
    padding-top: 42.5px;
    position: relative;
    padding-bottom: 22.5px;
  }
  .newsTab .tab li .left .tittle a{display: inline-block;width: 90%}

  .newsTab .tab li .left .tittle .date {
    position: absolute;
    right: 0;
    top: 47.5px;
    color: #999999;
    font-size: 14px;
    line-height: 18px;
  }

  .newsTab .wal span {
    display: block;
    text-align: center;
    font-size: 14px;
    color: #333;
    padding-top: 35px;
    padding-bottom: 90px
  }
  li {
    display: list-item;
    text-align: left;
  }
  .oh{
    min-height: 247px
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsList.vue